import { memo } from 'react';

import { useWishlist } from '~/features/wishlist/hooks/useWishlist';
import Heart from '~/icons/heart.svg';
import Pin from '~/icons/pin.svg';
import Link from '~/shared/components/Link/Link';
import { useNavigation } from '~/shared/utils/navigation/hooks/useNavigation';

import styles from './navigationHotLinks.module.css';

const NavigationHotLinks = memo(() => {
	const {
		data: { header: { favorites, findStores } = {} },
	} = useNavigation();
	const { data: { items: itemsWishList = [] } = {} } = useWishlist();

	return (
		<div className={styles.root}>
			{favorites ? (
				<Link
					className={styles.link}
					href={favorites.url}
					title={favorites.title}
				>
					<Heart />
					{`${favorites.text} (${itemsWishList.length})`}
				</Link>
			) : null}

			{findStores ? (
				<Link
					className={styles.link}
					href={findStores.url}
					title={findStores.title}
					isCustomStyle
				>
					<Pin />
					{findStores.text}
				</Link>
			) : null}
		</div>
	);
});

export default NavigationHotLinks;
